package horcrux.frontend.common.clients

import arrow.core.Either
import horcrux.common.HorcruxRequestSimpleError
import horcrux.common.api.dtos.types.DocumentChunkURL
import horcrux.common.api.dtos.types.LocalDocumentChunk
import horcrux.common.extensions.jsonClient
import horcrux.common.utils.runIOAndCatch
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.statement.readBytes
import io.ktor.http.HttpStatusCode

data class DocumentChunkClientError(
    val documentChunkURL: DocumentChunkURL,
    override val cause: Throwable,
) : HorcruxRequestSimpleError(HttpStatusCode.BadRequest)

object DocumentChunkClient {
    private val client: HttpClient = jsonClient()

    suspend fun submit(documentChunkURL: DocumentChunkURL): Either<DocumentChunkClientError, LocalDocumentChunk> =
        runIOAndCatch(mapError = { DocumentChunkClientError(documentChunkURL, it) }) {
            val httpResponse = client.get(documentChunkURL.value)
            LocalDocumentChunk.deserializeFromByteArray(httpResponse.readBytes()).bind()
        }
}
